import { render, staticRenderFns } from "./GroupDetailShouye.vue?vue&type=template&id=04e4bd7b&scoped=true"
import script from "./GroupDetailShouye.vue?vue&type=script&lang=js"
export * from "./GroupDetailShouye.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailShouye.vue?vue&type=style&index=0&id=04e4bd7b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e4bd7b",
  null
  
)

export default component.exports